<template>
               <div class="chartBox list_box" >
                    <div class="line_style">
                      <div class="td1">
                        <div class="tcenter">企业名称</div>
                      </div>
                      <div class="td2">
                        <div class="tcenter">数量</div>
                      </div>
                    </div>
                     <div
                      class="line_style hoverBtn"
                      v-for="(item, index) in data5"
                      :key="index"
                      @click="oNpart(item.companyName, item.companyId)"
                    >
                      <div class="td1">
                        <div class="num">{{ index + 1 }}</div>
                        <div class="text tit_overflow">
                          {{ item.companyName }}
                        </div>
                      </div>
                      <div class="td2">
                        <div class="num1">{{ item.sum }}</div>
                      </div>
                    </div>
                  </div>
</template>
<script>
  import echarts from 'echarts'
  import { mapActions } from "vuex";
import { setTimeout } from "timers";
 export default {
    name:'ParkRrmarkYuanqu',
    data() {
      return {
            data5: [
        {
          companyName: "",
          sum: "",
        },
      ],
   
      };
    },
     created() {
        this.initChartsCharfive()
      },
  methods: {
        ...mapActions("category", [
      "getChartGroup",
      "getChartData",
      "getReportData",
      "getReportVipcoms"
    ]),

     initChartsCharfive() {
      let _this = this;
      let data = {
        params: {
          gid: 1,
          chartTplCode: "pa_company_rank",
        },
      };
      this.getChartData({
        data: data,
        handle(res) {
          let list = res.message;
          _this.data5 = res.message.data.slice(0, 20);
        },
      });
    },
     //专利排行页面跳转
     oNpart(companyName, companyId) {
      this.$router.push({
        path: "/categoryDetail",
        query: {
          id: companyId,
          name: companyName,
        },
      });
    },
 }
 }


 </script>
    